import React from "react";
import { translate } from "react-i18next";

class HalftimeChart1 extends React.Component {
  constructor(props) {
    super();
    this.state = {
      data: undefined
    };
  }

  renderLine(i) {
    var percentage = 100 - i * 25;
    var stringPercentage = "" + percentage + "%";
    var time = parseInt(this.props.starttime) + i;
    var stringTime = "" + parseInt(time) + ":00";
    return (
      <tr key={i.toString()}>
        <td style={{ width: "10%" }}>
          <p>{stringTime}</p>
        </td>
        <td>
          <div className="progress">
            <div
              className="progress-bar"
              style={{ width: stringPercentage }}
            ></div>
          </div>
        </td>
        <td style={{ width: "5%" }}>
          <div>
            <label></label>
            <input type="radio" name="half{percentage}" value="{percentage}" />
          </div>
        </td>
      </tr>
    );
  }

  renderRows() {
    var indents = [];
    for (var i = 0; i < this.props.count; i++) {
      indents.push(this.renderLine(i));
    }
    return indents;
  }

  render() {
    return (
      <div>
        <table>
          <thead>
            {this.renderRows()}
          </thead>
        </table>
      </div>
    );
  }
}

export default translate()(HalftimeChart1);
